import { render, staticRenderFns } from "./WABATemplateMessage.vue?vue&type=template&id=049b4e77&scoped=true"
import script from "./WABATemplateMessage.vue?vue&type=script&lang=js"
export * from "./WABATemplateMessage.vue?vue&type=script&lang=js"
import style0 from "./WABATemplateMessage.vue?vue&type=style&index=0&id=049b4e77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b4e77",
  null
  
)

export default component.exports